import { render } from "./SessionExpired.vue?vue&type=template&id=5a1e1bdf&scoped=true&lang=pug"
import script from "./SessionExpired.vue?vue&type=script&lang=ts"
export * from "./SessionExpired.vue?vue&type=script&lang=ts"

import "./SessionExpired.vue?vue&type=style&index=0&id=5a1e1bdf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5a1e1bdf"

export default script